<div class="modal-content terms-modal">
    <div class="modal-header border-0">
        <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
    </div>
    
    <div class="modal-body terms-body">
        <div class="terms-container">
            <!-- Header Section -->
            <div class="terms-header">
                <div class="terms-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                        <polyline points="14 2 14 8 20 8"/>
                        <line x1="16" y1="13" x2="8" y2="13"/>
                        <line x1="16" y1="17" x2="8" y2="17"/>
                        <polyline points="10 9 9 9 8 9"/>
                    </svg>
                </div>
                <h2 class="terms-title">Términos y Condiciones</h2>
                <p class="terms-subtitle">Por favor, lea atentamente antes de continuar con su suscripción</p>
            </div>

            <!-- Content Section -->
            <div class="terms-content">
                <div class="content-wrapper">
                    <markdown [data]="md"></markdown>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer border-0 bg-light">
        <div class="footer-actions">
            <button type="button" 
                    class="btn btn-decline" 
                    (click)="activeModal.dismiss('Cross click')">
                <span class="btn-icon">✕</span>
                Rechazar
            </button>
            <button type="button" 
                    class="btn btn-accept" 
                    (click)="aceptar()">
                <span class="btn-icon">✓</span>
                Aceptar y Continuar
            </button>
        </div>
    </div>
</div>